import React from 'react'
import Header from './components/Header'
import StickyNav from './components/StickyNav'
import Hero from './components/Hero'
import WhyChoose from './components/WhyChoose'
import ICECooling from './components/ICECooling'
import HowItWorks from './components/HowItWorks'
import TreatmentNumber from './components/TreatmentNumber'
import TreatmentAreas from './components/TreatmentAreas'
import PricingTable from './components/PricingTable'
import Safety from './components/Safety'
import BeforeAfterCare from './components/BeforeAfterCare'
import MediSpaDifference from './components/MediSpaDifference'
import WhatHappens from './components/WhatHappens'
import Testimonials from './components/Testimonials'
import FAQ from './components/FAQ'
import PackagePolicy from './components/PackagePolicy'
import BeforeAfterGallery from './components/BeforeAfterGallery'
import LaserDevice from './components/LaserDevice'
import FinalCTA from './components/FinalCTA'
import OfferBanner from './components/OfferBanner'
import { LanguageProvider } from './i18n/LanguageContext'
import { useScrollAnimation } from './hooks/useScrollAnimation'

function App() {
  useScrollAnimation()

  // Analytics: Google Analytics 4 (G-J67R9N4BCP) loaded via gtag.js in index.html

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-white">
        <Header />
        <Hero />
        <WhyChoose />
        <LaserDevice />
        <WhatHappens />
        <BeforeAfterCare />
        <div id="gallery">
          <BeforeAfterGallery />
        </div>
        <Testimonials />
        <div id="faq">
          <FAQ />
        </div>
        <OfferBanner ctaLocation="pricing" variant="pricing" />
        <div id="pricing">
          <PricingTable />
        </div>
        <Safety />
        <FinalCTA />
        <StickyNav />
      </div>
    </LanguageProvider>
  )
}

export default App
